// jshint strict:false, undef:false, unused:false

/*/
	Shopstrap JS Init
	Stephen Ginn at Crema Design Studio
	Last Updated on 2021-05-24
/*/

// Load Products
// spinner('[data-spinner]');
load_product('#product-box');

// Load Cart Page
const cartForm = document.getElementById('cartform');
if (cartForm) new Cart(cartForm);

// Data Masking
document.querySelectorAll("[type=tel]").forEach(el => {
	IMask(el, {mask: '(000) 000-0000'});
});

// Crema Captcha v4.3.8
captcha(".contact-form, [data-captcha]");

contact({
	loaded(settings) {
		this.btn.addEventListener('click', e => {
			this.classList.add("sending");
		});
	},
	success() {
		this.classList.remove("sending");
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-success";
		
		setTimeout(() => {
			this.alert.className = "d-none";
			this.reset();
		}, 3000);
	},
	error() {
		this.classList.remove("sending");
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-danger";
		
		setTimeout(() => {
			this.alert.className = "d-none";
		}, 3000);
		
		sendAlerts(this); 
	}
});

// const staffModal = document.getElementById('modal-staff');

// if (staffModal) {
// 	staffModal.addEventListener('show.bs.modal', e => {
// 		var modal = this,
// 			form = modal.querySelector('form'),
// 			btn = e.relatedTarget,
// 			staff = JSON.parse(btn.getAttribute('data-attr'));
		
// 		// Update the modal's content
// 		modal.querySelector('.modal-title').textContent = staff.name;
// 		form.reset();
// 		form.setAttribute('data-action', staff.action);
// 		form.subject.value = shop.name + " Contact Form | " + staff.title;
// 		form.send.setAttribute("disabled", true);
// 	});
// }
